var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{attrs:{"aria-label":"This attraction is featered in the follow:"}},_vm._l((_vm.badges),function(badge){return _c('a',{key:badge.name,attrs:{"href":badge.page}},[_c('li',[_c('img',{attrs:{"src":badge.imageUrl,"alt":badge.name}})])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }